import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OrderStatus {
  status?: string
  error?: string
}

interface OrderPaidAmount {
  amountPaid?: number
  error?: string
}

interface OrderState {
  [id: string]: OrderStatus & OrderPaidAmount // Combine OrderStatus and OrderPaidAmount
}

const initialState: OrderState = {}

export const backofficeOrdersSlice = createSlice({
  name: 'backofficeOrders',
  initialState,
  reducers: {
    setOrderStatus: (state, action: PayloadAction<{ id: string; status: string }>) => {
      const { id, status } = action.payload
      if (!state[id]) {
        state[id] = {}
      }
      state[id].status = status
    },
    setOrderPaidAmount: (state, action: PayloadAction<{ id: string; amountPaid: number }>) => {
      const { id, amountPaid } = action.payload
      if (!state[id]) {
        state[id] = {}
      }
      state[id].amountPaid = amountPaid // Set the paid amount
    },
    setOrderError: (state, action: PayloadAction<{ id: string; error: string }>) => {
      const { id, error } = action.payload
      if (!state[id]) {
        state[id] = {}
      }
      state[id].error = error
    },
  },
})

export const { setOrderStatus, setOrderPaidAmount, setOrderError } = backofficeOrdersSlice.actions

export default backofficeOrdersSlice.reducer
